/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import proptypes from 'prop-types';
const { string, bool, arrayOf, oneOfType } = proptypes;
import { Typography, Link, Badge } from '@one-thd/sui-atomic-components';

const KeyProductFeatureValue = (props) => {
  const [hideMore, setHideMore] = useState(true);
  const maxLimit = 3;
  const { value, simple, inverseText, responsiveTileGrid } = props;
  const isValueString = typeof value === 'string';

  if (isValueString) {
    return <span className={inverseText ? 'sui-font-bold' : ''}>{value}</span>;
  }

  const shownLabel = hideMore ? value.slice(0, maxLimit) : value;

  const labels = () => {
    return simple ? (
      <Badge variant="strong" color="medium" size="small">{shownLabel[0]}</Badge>
    ) : (shownLabel.map((label) => (
      <Typography component="p" truncate={responsiveTileGrid} variant={inverseText ? 'body-sm': 'h2'} color={inverseText ? 'primary' : 'subtle'} weight={inverseText ? 'bold' : 'regular'} key={label}>{label}</Typography>
    )));
  };

  return (
    <>
      {
        shownLabel && labels()
      }
      {
        value.length > maxLimit && !simple && (
          <>
            <div className="sui-text-left" data-testid="show-toggle-btn">
              <Link
                component="button"
                onClick={() => setHideMore(!hideMore)}
              >{!hideMore ? 'Show Less' : 'Show More'}
              </Link>
            </div>
          </>
        )
      }
    </>
  );

};

KeyProductFeatureValue.propTypes = {
  value: oneOfType([string, arrayOf(string)]),
  simple: bool,
  inverseText: bool,
  responsiveTileGrid: bool
};

KeyProductFeatureValue.defaultProps = {
  value: null,
  simple: false,
  inverseText: false,
  responsiveTileGrid: false
};

export { KeyProductFeatureValue };
